
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctComingFrom as ObiDuctComingFromElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-coming-from.js';
 
 
 

 
 export const ObiDuctComingFrom = createComponent({
   react: React,
   tagName: 'obi-duct-coming-from',
   elementClass: ObiDuctComingFromElement,
   events: {
     
   }
  });
 
 